// @flow
/* eslint-disable react/no-danger */
import React from 'react';
import type {Shape as HitShape} from '../Hit/Hit';
import './MapHoverThumbnail.less';

type Props = {
    hit: HitShape
};

const icon = {
    __html: `
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="82" height="88" viewBox="0 0 82 88">
        <defs>
            <path id="map-hover-pin" d="M0 5.999A6.002 6.002 0 0 1 6 0h60c3.314 0 6 2.69 6 5.999v59.996c0 3.313-2.682 6.042-5.99 6.096l-18.473.297c-1.651.027-3.97.962-5.181 2.09l-3.485 3.246c-1.21 1.128-3.172 1.128-4.383 0l-3.485-3.246c-1.21-1.127-3.543-2.062-5.193-2.087l-19.805-.305C2.688 72.036 0 69.303 0 65.995V5.999z"/>
            <filter id="gauss-filter" width="123.6%" height="121.6%" x="-11.8%" y="-8.3%" filterUnits="objectBoundingBox">
                <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/>
                <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2.5"/>
                <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
            </filter>
        </defs>
        <g fill-rule="evenodd" transform="translate(5 3)">
            <use fill="#000" filter="url(#gauss-filter)" xlink:href="#map-hover-pin"/>
            <use fill="#FFF" xlink:href="#map-hover-pin"/>
        </g>
    </svg>
`
};

const MapHoverThumbnail = ({hit}: Props) => {
    if (hit.images[0]) {
        return (
            <div className="MapHoverThumbnail">
                <div dangerouslySetInnerHTML={icon} />
                <img
                    className="MapHoverThumbnail__img"
                    src={hit.images[0].lowResSrc}
                />
            </div>
        );
    }
    return null;
};

export default MapHoverThumbnail;
